"use client";

import { useState } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Provider as JotaiProvider } from "jotai";
import WalletProviders from "@/components/WalletProviders";
import ErrorBoundary from "@/components/ErrorBoundary";

export const Providers = ({ children }: { children: React.ReactNode }) => {
  const [client] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            // Market data is polled on an explicit interval per-query; don't also refetch
            // on every window focus.
            refetchOnWindowFocus: false,
            staleTime: 5_000,
            retry: 1,
          },
        },
      })
  );

  // No theme provider: <html data-theme> is the source of truth and useTheme() subscribes
  // to it directly (see lib/theme.tsx).
  //
  // WalletProviders sits INSIDE QueryClientProvider, wagmi v3 requires a react-query client
  // and will throw at mount without one above it.
  return (
    <QueryClientProvider client={client}>
      <JotaiProvider>
        {/* Contains any render/effect crash (most likely an async wallet-adapter init) so a
            single failure shows a retry card instead of Next's whole-page "couldn't load". */}
        <ErrorBoundary fallbackLabel="The app hit an unexpected error.">
          <WalletProviders>{children}</WalletProviders>
        </ErrorBoundary>
      </JotaiProvider>
    </QueryClientProvider>
  );
};
